<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent value="" max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ modalTitle }} Address</span>
          <v-spacer></v-spacer>
          <v-btn text icon color="grey" @click="onClose">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-container>
            <confirm-delete-in-modal
              v-if="showConfirmDelete"
              @confirmed="onConfirmDelete"
            ></confirm-delete-in-modal>
            <v-form ref="form" v-model="valid">
              <v-row>
                <v-col class="py-1" cols="12" sm="4">
                  <v-autocomplete
                    required
                    :rules="[rules.required]"
                    v-model="addressTypeValue"
                    :items="types"
                    item-text="name"
                    item-value="id"
                    label="Type"
                    dense
                    autocomplete="off"
                    outlined
                  ></v-autocomplete>
                </v-col>
                <v-col class="py-1" cols="12">
                  <v-text-field
                    label="Address 1"
                    v-model="address1Value"
                    required
                    :rules="[]"
                    dense
                    autofocus
                    autocomplete="off"
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col class="py-1" cols="12">
                  <v-text-field
                    label="Address 2"
                    v-model="address2Value"
                    required
                    :rules="[]"
                    dense
                    autocomplete="off"
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col class="py-1" cols="12" sm="5">
                  <v-text-field
                    label="City"
                    v-model="cityValue"
                    required
                    :rules="[rules.required]"
                    dense
                    autocomplete="off"
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col class="py-1" col="6" sm="4">
                  <v-autocomplete
                    required
                    :rules="[rules.required]"
                    v-model="stateValue"
                    :items="states"
                    item-text="name"
                    item-value="id"
                    label="State"
                    dense
                    autocomplete="off"
                    outlined
                  ></v-autocomplete>
                </v-col>
                <v-col class="py-1" cols="6" sm="3">
                  <v-text-field
                    label="ZIP"
                    v-model="postalCodeValue"
                    required
                    :rules="[rules.required, rules.zip]"
                    v-on:keyup.enter="onSave"
                    dense
                    autocomplete="off"
                    outlined
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn v-if="showDelete" color="blue darken-1" text @click="onDelete"
            >Delete</v-btn
          >
          <v-btn color="primary tile" @click="onSave"
            >&nbsp;&nbsp;&nbsp;Save&nbsp;&nbsp;&nbsp;</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { STATES } from "../../../helpers/StaticLists";
const ConfirmDeleteInModal = () =>
  import(
    /* webpackChunkName: "components-customers-modals-ConfirmDeleteInModal" */ `./ConfirmDeleteInModal.vue`
  );

export default {
  name: "AddressFormModal",
  props: {
    addressId: Number,
    addressCustomerId: Number
  },
  components: {
    ConfirmDeleteInModal
  },
  data: () => ({
    dialog: true,
    modalTitle: "Add",
    valid: true,
    showConfirmDelete: false,
    addressTypeValue: "main",
    address1Value: null,
    address2Value: null,
    cityValue: null,
    stateValue: null,
    postalCodeValue: null,
    types: [
      { id: "main", name: "Main" },
      { id: "home", name: "Home" },
      { id: "office", name: "Office" },
      { id: "bill", name: "Billing" },
      { id: "ship", name: "Shipping" }
    ],
    states: STATES,
    rules: {
      required: value => !!value || "Required",
      email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || "Invalid email";
      },
      phone: value => {
        return (
          (value && value.match(/\d/g) && value.match(/\d/g).length >= 10) ||
          "Invalid phone number"
        );
      },
      zip: value => {
        // eslint-disable-next-line no-useless-escape
        const pattern = /^(\d{5}(?:\-\d{4})?)$/;
        return pattern.test(value) || "Invalid ZIP";
      }
    }
  }),
  computed: {
    isAddNew() {
      return parseInt(this.addressId) == -1;
    },
    showDelete() {
      return !this.isAddNew && !this.showConfirmDelete;
    },
    currentAddress() {
      let address = this.$store.getters["entities/addresses/find"](
        this.addressId
      );
      return address;
    },
    user() {
      return this.$store.getters["entities/users/find"](
        this.$store.getters["entities/settings/query"]().first().userId
      );
    }
  },
  created() {
    if (this.addressId > 0) {
      this.modalTitle = "Update";
      this.addressTypeValue = this.currentAddress.type;
      this.address1Value = this.currentAddress.address1;
      this.address2Value = this.currentAddress.address2;
      this.cityValue = this.currentAddress.city;
      this.stateValue = this.currentAddress.state;
      this.postalCodeValue = this.currentAddress.postalCode;
    }
  },
  methods: {
    onClose() {
      if (this.$parent.showAppointmentFormModal) {
        this.$root.$children[0].$refs[
          "customer-editor-modals"
        ].showAddressFormModal = false;
      } else {
        this.$root.$children[0].showCustomerEditorModals = false;
      }
    },
    onSave() {
      if (this.$refs.form.validate()) {
        if (this.isAddNew) {
          const tempId = this.$uuidv4();
          this.$store.dispatch("entities/addresses/createAddress", {
            id: tempId,
            tempId: tempId,
            isDirty: true,
            accountId: this.user.accountId,
            customerId:
              this.addressCustomerId || parseInt(this.user.currentCustomerId),
            type: this.addressTypeValue,
            address1: this.address1Value,
            address2: this.address2Value,
            city: this.cityValue,
            state: this.stateValue,
            postalCode: this.postalCodeValue
          });
        } else if (this.addressId > 0) {
          this.$store.dispatch("entities/addresses/updateAddress", {
            accountId: this.user.accountId,
            customerId:
              this.addressCustomerId || parseInt(this.user.currentCustomerId),
            id: this.addressId,
            isDirty: true,
            type: this.addressTypeValue,
            address1: this.address1Value,
            address2: this.address2Value,
            city: this.cityValue,
            state: this.stateValue,
            postalCode: this.postalCodeValue
          });
        }
        this.onClose();
      }
    },
    onDelete() {
      this.showConfirmDelete = true;
    },
    onConfirmDelete() {
      this.$store.dispatch("entities/addresses/deleteAddress", {
        accountId: this.user.accountId,
        id: this.addressId,
        isDirty: true
      });
      this.onClose();
    }
  }
};
</script>
<style scoped lang="stylus"></style>
